// PhoneInput.jsx
import { memo, useCallback, useEffect, useState, useMemo, useImperativeHandle, forwardRef } from 'react'
import CountryPicker from 'react-phone-input-2'
import 'react-phone-input-2/lib/high-res.css'
// @ts-expect-error TS7016 -- MIGRATION: not approved, fix when encountered
import { InputText } from 'ui_kit_qmd'
import './PhoneInput.scss'
import ArrowImg from '../../images/common/backArrow.png'
import { errorCodes, getUserFriendlyErrorMessage } from '../../utils/errormessages'

const countryPickerButtonStyle = {
  border: 'none',
  borderRadius: '4px 0 0 4px',
  background: '#eff3f6',
}

const textInputStyle = {
  borderRadius: '0 4px 4px 0',
}

const inputTextWrapperStyle = {
  width: '100%',
}

export const PhoneInputV2 = memo(
  forwardRef(
    (
      {
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        id,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        inputLabel,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        disabled,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        error,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        loading,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        setCountryCode,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        setIsPhoneCorrect,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        phoneCountryCode = '1',
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        phoneNumber,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        phoneCountry = 'us',
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        onChangeCountry,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        onChangeNumber,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        isPhoneCorrect,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        checkedPhoneNumber,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        isOldNumberCorrect,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        isSuccess,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        setPhoneError = null,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        className = '',
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        allowEmpty = false,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        validatePhoneNumber,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        isPhoneValidated,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        setIsPhoneValidated,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        localInputError,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        setLocalInputError,
      },
      ref,
    ) => {
      const [isFirstRender, setIsFirstRender] = useState(true)
      const [buttonWidth, setButtonWidth] = useState(null)
      const [oldNumber, setOldNumber] = useState(phoneNumber)
      const [phoneInputMainWrapperWidth, setPhoneInputMainWrapperWidth] = useState(0)

      const [isBlurred, setBlurred] = useState(false)
      const [isValidating, setIsValidating] = useState(false)

      // Expose validate function to parent via ref

      const handleValidation = useCallback(async () => {
        setLocalInputError('')
        if (typeof setPhoneError === 'function') {
          setPhoneError('')
        }

        setIsValidating(true)

        if (!phoneNumber.trim()) {
          if (allowEmpty) {
            setLocalInputError('')
            setIsPhoneCorrect(true)
            setIsPhoneValidated(true)
            setIsValidating(false)
            return true
          }
          // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
          const errorMessage = getUserFriendlyErrorMessage(errorCodes.FIELD_REQUIRED, null, 'Phone number')
          setLocalInputError(errorMessage)
          if (typeof setPhoneError === 'function') {
            setPhoneError(errorMessage)
          }

          setIsPhoneCorrect(false)
          setIsPhoneValidated(false)
          setIsValidating(false)
          return false
        }

        try {
          if (validatePhoneNumber) {
            const validationResult = await validatePhoneNumber(phoneCountryCode, phoneNumber, phoneCountry)

            if (validationResult.isValid) {
              setLocalInputError('')
              setIsPhoneCorrect(true)
              setIsPhoneValidated(true)
              console.log('Validation successful')
              setIsValidating(false)
              return true
            }
            setLocalInputError(validationResult.errorMessage)
            if (typeof setPhoneError === 'function') {
              setPhoneError(validationResult.errorMessage)
            }
            setIsPhoneCorrect(false)
            setIsPhoneValidated(false)
            console.log('Validation failed')
            setIsValidating(false)
            return false
          }
          // If no validation function provided, assume valid
          setLocalInputError('')
          setIsPhoneCorrect(true)
          setIsPhoneValidated(true)
          setIsValidating(false)
          return true
        } catch (error) {
          // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
          let errorMessage = getUserFriendlyErrorMessage(errorCodes.ENTER_VALID, null, 'Phone number')
          // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
          if (error.message?.includes('PhoneNumberNotValid')) {
            // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
            errorMessage = getUserFriendlyErrorMessage(errorCodes.ENTER_VALID, null, 'Phone number')
          }
          setLocalInputError(errorMessage)
          if (typeof setPhoneError === 'function') {
            setPhoneError(errorMessage)
          }
          setIsPhoneCorrect(false)
          setIsPhoneValidated(false)
          console.log('Validation failed with error:', errorMessage)
          setIsValidating(false)
          return false
        }
      }, [
        phoneNumber,
        phoneCountryCode,
        phoneCountry,
        allowEmpty,
        setIsPhoneCorrect,
        setPhoneError,
        validatePhoneNumber,
        setIsPhoneValidated,
      ])

      useImperativeHandle(ref, () => ({
        validate: handleValidation,

        isPhoneValidated,
      }))

      // Initialize PhoneInput and set up event listeners
      useEffect(() => {
        const phoneInputElement = document.getElementById(id)
        if (!phoneInputElement) return

        const arrow = phoneInputElement.querySelector('.arrow')
        const formControl = phoneInputElement.querySelector('.form-control')
        const selectedFlag = phoneInputElement.querySelector('.selected-flag')

        if (formControl) {
          const countryCodeSpan = document.createElement('span')
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          const text = document.createTextNode(`+${formControl.value.slice(1)}`)
          countryCodeSpan.classList.add('phone-input-country-code')
          countryCodeSpan.appendChild(text)

          const arrowImg = document.createElement('img')
          arrowImg.src = ArrowImg
          arrowImg.classList.add('phone-input-country-button-arrow')

          if (arrow) {
            arrow.appendChild(arrowImg)
          }
          if (selectedFlag) {
            selectedFlag.appendChild(countryCodeSpan)
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            selectedFlag.onmouseover = function () {
              // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
              this.style.backgroundColor = 'transparent'
            }
          }
        }

        const handleResize = () => {
          setPhoneInputMainWrapperWidth(phoneInputElement.clientWidth)
        }
        window.addEventListener('resize', handleResize)
        handleResize()

        if (!disabled && formControl) {
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          setCountryCode(formControl.value.slice(1))
        }

        setIsFirstRender(false)

        return () => {
          if (selectedFlag) {
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            selectedFlag.onmouseover = null
          }
          window.removeEventListener('resize', handleResize)
        }
      }, [id, disabled, setCountryCode])

      // Update country code display and button styles when `phoneCountryCode` changes
      useEffect(() => {
        const phoneInputElement = document.getElementById(id)
        if (!phoneInputElement) return

        const countryCodeSpan = phoneInputElement.querySelector('.phone-input-country-code')
        const button = phoneInputElement.querySelector('.react-tel-input .selected-flag')
        const arrow = phoneInputElement.querySelector('.react-tel-input .selected-flag .arrow')

        if (countryCodeSpan) {
          countryCodeSpan.innerHTML = `+${phoneCountryCode}`
        }

        if (button) {
          const computedButtonWidth = phoneCountryCode.length * 12 + 75
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          button.style.width = `${computedButtonWidth}px`
          // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
          setButtonWidth(computedButtonWidth)
        }

        if (arrow) {
          const computedArrowMargin = phoneCountryCode.length * 12 + 15
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          arrow.style.marginLeft = `${computedArrowMargin}px`
        }
      }, [phoneCountryCode, id])

      // Handle local input errors based on validation state
      useEffect(() => {
        if (allowEmpty && !phoneNumber.trim()) {
          if (typeof setPhoneError === 'function') {
            setPhoneError('')
          }
          setIsPhoneCorrect(true)
          setIsPhoneValidated(true)
        } else if (
          phoneNumber === oldNumber &&
          !isOldNumberCorrect &&
          isOldNumberCorrect !== '' &&
          !loading &&
          error !== getUserFriendlyErrorMessage(errorCodes.PHONE_NOT_UNIQUE)
        ) {
          // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
          const errorMessage = getUserFriendlyErrorMessage(errorCodes.ENTER_VALID, null, inputLabel.toLowerCase())
          setLocalInputError(errorMessage)
          setIsPhoneValidated(false)
        } else {
          setLocalInputError('')
        }
      }, [
        phoneNumber,
        allowEmpty,
        oldNumber,
        isOldNumberCorrect,
        loading,
        error,
        inputLabel,
        setPhoneError,
        setIsPhoneCorrect,
        setIsPhoneValidated,
      ])

      useEffect(() => {
        if (!disabled && typeof setPhoneError === 'function') {
          setPhoneError(localInputError)
        }
      }, [localInputError, disabled, setPhoneError])

      const onFocusCountryPicker = useCallback(() => {
        const phoneInputElement = document.getElementById(id)
        // @ts-expect-error TS18047 -- MIGRATION: not approved, fix when encountered
        const searchContainer = phoneInputElement.querySelector('.search')
        const searchBox = searchContainer?.querySelector('.search-box')
        const clearButtonContainer = document.createElement('div')
        clearButtonContainer.classList.add('search-country-clear-button-container')
        clearButtonContainer.style.right = `${
          ((searchContainer?.clientWidth || 0) - (searchBox?.clientWidth || 0)) / 2
        }px`
        // @ts-expect-error TS18047 -- MIGRATION: not approved, fix when encountered
        clearButtonContainer.addEventListener('click', () => phoneInputElement.querySelector('.search-box').focus())
        searchContainer?.appendChild(clearButtonContainer)
      }, [])

      useEffect(() => {
        // @ts-expect-error TS7034 -- MIGRATION: not approved, fix when encountered
        let timeout

        if (isBlurred) {
          if (phoneNumber !== oldNumber) {
            // Number has changed, validate after a delay
            timeout = setTimeout(() => {
              setOldNumber(phoneNumber)
              handleValidation()
              setBlurred(false)
            }, 250)
          } else {
            // Number hasn't changed, no need to validate
            setBlurred(false)
          }
        }

        return () => {
          // @ts-expect-error TS7005 -- MIGRATION: not approved, fix when encountered
          if (timeout) {
            clearTimeout(timeout)
            setBlurred(false)
          }
        }
      }, [isBlurred, phoneNumber, oldNumber, handleValidation])

      const onBlur = () => setBlurred(true)

      const onChangeCountryAction = useCallback(
        // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
        (code, country) => {
          setLocalInputError('')
          if (typeof setPhoneError === 'function') {
            setPhoneError('')
          }
          onChangeCountry(code, country)
          setIsPhoneValidated(false)
        },
        [onChangeCountry, setPhoneError, setIsPhoneValidated],
      )

      const onChangeNumberAction = useCallback(
        // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
        (value) => {
          setLocalInputError('')
          if (typeof setPhoneError === 'function') {
            setPhoneError('')
          }
          onChangeNumber(value)
          setIsPhoneValidated(false)
        },
        [onChangeNumber, setPhoneError, setIsPhoneValidated],
      )

      const countryPickerContainerStyle = useMemo(
        () => ({
          width: 'max-content',
          opacity: isFirstRender ? 0 : 1,
        }),
        [isFirstRender],
      )

      const countryPickerInputStyle = useMemo(
        () => ({
          width: buttonWidth,
          height: 60,
          border: 'none',
          borderRadius: 0,
          background: 'transparent',
          paddingLeft: 0,
          color: 'transparent',
        }),
        [buttonWidth],
      )

      const countryPickerDropdownStyle = useMemo(
        () => ({
          background: '#eff3f6',
          fontFamily: 'Helvetica',
          fontWeight: '400',
          fontSize: 16,
          width: phoneInputMainWrapperWidth,
        }),
        [phoneInputMainWrapperWidth],
      )

      const checkIsSuccess =
        !loading && // Ensure loading is false
        phoneNumber.length > 0 &&
        isPhoneValidated &&
        (isSuccess ||
          (phoneNumber === checkedPhoneNumber && isPhoneCorrect) ||
          (oldNumber === checkedPhoneNumber && isPhoneCorrect) ||
          (phoneNumber === oldNumber && isOldNumberCorrect))

      const shouldShowError = !disabled && !isValidating && !loading && (error || localInputError)

      console.log('--- PhoneInputV2 Error Condition Logs ---')
      console.log('disabled:', disabled)
      console.log('isValidating:', isValidating)
      console.log('error:', error)
      console.log('localInputError:', localInputError)
      console.log('shouldShowError:', shouldShowError)
      console.log('phoneNumber:', phoneNumber)
      console.log('oldNumber:', oldNumber)
      console.log('isOldNumberCorrect:', isOldNumberCorrect)
      console.log('loading:', loading)
      console.log('isPhoneCorrect:', isPhoneCorrect)
      console.log('-------------------------------------------')

      return (
        <div id={id} className={`phone-input-main-wrapper${className ? ` ${className}` : ''}`}>
          <div
            className={`phone-input-container${disabled ? 'phone-input-container--disabled' : ''}${
              shouldShowError ? 'error' : ''
            }`}
            onKeyDown={onFocusCountryPicker}>
            <CountryPicker
              country={phoneCountry}
              enableSearch
              containerStyle={countryPickerContainerStyle}
              searchPlaceholder='Search'
              // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
              inputStyle={countryPickerInputStyle}
              buttonStyle={countryPickerButtonStyle}
              dropdownStyle={countryPickerDropdownStyle}
              buttonClass='phone-input-country-button'
              onChange={onChangeCountryAction}
              disabled={disabled}
            />
            <form autoComplete='off' style={inputTextWrapperStyle}>
              <InputText
                containerStyle={textInputStyle}
                label={inputLabel}
                view='visitType'
                setValue={onChangeNumberAction}
                onUserBlur={onBlur}
                isError={
                  !disabled &&
                  (shouldShowError ||
                    (!allowEmpty &&
                      phoneNumber === oldNumber &&
                      !isOldNumberCorrect &&
                      isOldNumberCorrect !== '' &&
                      !loading))
                }
                success={phoneNumber.length === 0 ? false : checkIsSuccess}
                value={phoneNumber}
                disabled={disabled}
                isDisableAutocomplete
              />
            </form>
          </div>
          {shouldShowError && !disabled ?
            <div className='phone-input-local-error-label'>{error || localInputError}</div>
          : null}
        </div>
      )
    },
  ),
)
